module.exports = __webpack_public_path__ + "static/media/qa.ba64a79a.webp";